import gql from 'graphql-tag';

export const GET_AUTH_TENANT_LIST = gql`
  query getAuthTenantList {
    getAuthTenantList
  }
`;


export const GET_PREFILL_KYC_INFO = gql`
  query getPrefillKycInfo {
    getPrefillKycInfo
  }
`;
